export default __webpack_public_path__ + "static/media/Person.32e24285.svg";